"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipButtonHandler = void 0;
var Widget_1 = require("../tools/Widget");
var Tooltip_1 = require("./Tooltip");
var TooltipButtonHandler = (function (_super) {
    __extends(TooltipButtonHandler, _super);
    function TooltipButtonHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipButtonHandler.prototype.init = function () {
        var _this = this;
        this.el.on("click", ".tooltip-button", function (e) { return _this.handleClick(e); });
    };
    TooltipButtonHandler.prototype.handleClick = function (e) {
        var $button = $(e.target).closest(".tooltip-button");
        var className = $button.data("tooltipclass");
        var content = $button.find("script[type='text/tooltip']").text();
        Tooltip_1.Tooltip.getInstance().show(content, $button[0], className);
    };
    return TooltipButtonHandler;
}(Widget_1.Widget));
exports.TooltipButtonHandler = TooltipButtonHandler;
